import { render, staticRenderFns } from "./QuizOpened.vue?vue&type=template&id=4cd1452a&scoped=true&"
import script from "./QuizOpened.vue?vue&type=script&lang=js&"
export * from "./QuizOpened.vue?vue&type=script&lang=js&"
import style0 from "./QuizOpened.vue?vue&type=style&index=0&id=4cd1452a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd1452a",
  null
  
)

export default component.exports